import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import api from '../../../utils/api';

export const RedeemModal = ({ show, onHide, isCheckFolioResponse, selectedRedeemFund, roomId, isFiltered, setRedeemSuccess, selectedCard }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError, // ✅ add this
  } = useForm();
  const [isTransactionAmountDisabled, setTransactionAmountDisabled] = useState(true);
  const [allUnitsValue, setAllUnitsValue] = useState(""); // State to track All Units selection
  const [amount, setAmount] = useState(null)
  const [isSelectedFund, setIsSelectedFund] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  
  const [modalTitle, setModalTitle] = useState("");

useEffect(() => {
  if (selectedRedeemFund && selectedRedeemFund.fund_name) {
    let formattedFundName = selectedRedeemFund.fund_name;
    if (formattedFundName.includes("Fund")) {
      formattedFundName = formattedFundName.substring(0, formattedFundName.indexOf("Fund") + 4);
    }

    const currentValue = Math.round(Number(selectedRedeemFund?.aum_as_per_rta || 0));
    const title = `${formattedFundName} (${selectedRedeemFund.folio_number}) | Current Value : ₹${currentValue}`;
    setModalTitle(title);
  } else {
    setModalTitle("");
  }
}, [selectedRedeemFund]);

  useEffect(() => {
    if (selectedRedeemFund && selectedRedeemFund.fund_name) {
      setIsSelectedFund(true); // Enable button if valid selectedRedeemFund
    } else {
      setIsSelectedFund(false); // Disable button if no valid fund
    }
  }, [selectedRedeemFund]);
  
  useEffect(() => {
    if (show) {
      reset(); // Reset form fields
      setAllUnitsValue(""); // Reset All Units
      setAmount(null); // Reset amount
      setTransactionAmountDisabled(true); // Reset disable state
      setIsSubmitting(false); // Reset button state
    }
  }, [show]);
  
  const goalId = selectedCard?._id;
  const goalName = selectedCard?.text;
  
  const handleAllUnitsChange = (event) => {
    const value = event.target.value;
    setAllUnitsValue(value);
    setTransactionAmountDisabled(value === "Yes" || value === "");
  };
  const handleAllUnitsChange2 = (event) => {

    // console.log("event.target.value", event.target.value);
    setAmount(event.target.value)
  };
  const currentFundValue = Number(
    selectedRedeemFund?.aum_as_per_rta || 0
  );

  const enteredAmount = Number(amount || 0);

  const isAmountExceedingCurrentValue =
    allUnitsValue === "No" &&
    amount !== null &&
    amount !== "" &&
    (
      !Number.isFinite(enteredAmount) ||
      enteredAmount > currentFundValue
    );

  
 
  
   console.log('isFilteredddd,', selectedRedeemFund);
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      // Default values and constants
      const currentYear = new Date().getFullYear();
      let allUnit = data.allUnits === 'Yes' ? 1 : 0;
      const minRedemptionAmt = selectedRedeemFund?.minRedemptionAmt || 0;
      const staticTargetYear = isFiltered?.goalYear || currentYear;
      const staticCAGR = parseInt(isFiltered.expectedReturn);
      let numberOfUnit = data?.redeemFormAmount;
      
      if (data.allUnits === 'Yes') {
        numberOfUnit = selectedRedeemFund?.aum_as_per_rta
      }
      else {
        numberOfUnit = data?.redeemFormAmount;
      }
      // console.log("staticCAGR", staticCAGR, numberOfUnit, allUnit, isCheckFolioResponse?.investor_name);
      
      // Get the current fund value
      const currentFundValue = Number(
        selectedRedeemFund?.aum_as_per_rta || 0
      );

      // Get the entered redemption amount
      const enteredAmount = Number(data?.redeemFormAmount || 0);

      // Prevent redemption amount from exceeding current fund value
      if (
        data.allUnits === "No" &&
        enteredAmount > currentFundValue
      ) {
        setError("redeemFormAmount", {
          type: "manual",
          message: `Redeem amount cannot exceed the current fund value of ₹${currentFundValue.toLocaleString("en-IN")}.`,
        });

        setIsSubmitting(false);
        return;
      }
      
      if (!allUnit && parseInt(numberOfUnit) < parseInt(minRedemptionAmt)) {
        setError("redeemFormAmount", {
          type: "manual",
          message: `Minimum redeemable amount is ₹${minRedemptionAmt}`,
        });
        setIsSubmitting(false);
        return;
      }
      // Validate minimum redemption amount
      
      // Prepare SIP Deficit amount if applicable
      const deficitAmount = Math.round(
        numberOfUnit * Math.pow((1 + staticCAGR / 100), (staticTargetYear - currentYear))
      );
      
      // Build the final payload
      const allSIPData = {
        allUnit,
        // uid: selectedRedeemFund?.uid?.replace('/', ''),
        uid: selectedRedeemFund?.uid,
        transType: 'redemption',
        fundName: selectedRedeemFund?.fund_name,
        folioNo: selectedRedeemFund?.folio_number,
        ifsc_code: selectedRedeemFund?.ifsc_code,
        numberofunit: numberOfUnit,
        goal_name: selectedRedeemFund?.goal_name || goalName,
        minRedemptionAmt,
        schemeCode: selectedRedeemFund?.scheme_code,
        goalId: selectedRedeemFund?.goal_id || goalId,
        staticTargetAmount: isFiltered?.TargetAmount,
        // client_id: selectedRedeemFund?.client_id,
        client_id: roomId,  //by girish sir on 28-05-2024
        ucc: isCheckFolioResponse?.ucc,
        email: isCheckFolioResponse?.email,
        mobile: isCheckFolioResponse?.mobile,
        sipDeficit: deficitAmount,
        // accountNo: isCheckFolioResponse?.accountNumber,
        accountNo: selectedRedeemFund?.account_number,
        goalYear: staticTargetYear,
        investorName: isCheckFolioResponse?.investor_name,
        productCode: selectedRedeemFund?.product_code,
        member_id: selectedRedeemFund?.pan_client_id,
        invUCCCode: selectedRedeemFund?.inv_ucc_code,
        investorName:selectedRedeemFund?.investor_name,
        // email: selectedRedeemFund?.email,
        // mobile: selectedRedeemFund?.mobile,
        // accountNo: selectedRedeemFund?.account_number,	
        // investorName: selectedRedeemFund?.investor_name,
      };
      
      // console.log("Form submitted:", allSIPData);
      const response = await api.post(`advisor/redeemFolio`, allSIPData);
      // console.log("redeemFolio API Response", response.data);
      reset()
      onHide()
      setRedeemSuccess(true)
      setAllUnitsValue("")
      setIsSubmitting(false);
      // Proceed with further actions, e.g., API call, after submission
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }
  
  // console.log("amount", amount);
  
  return (
    <Modal show={show} onHide={onHide} >
  
  <Modal.Header closeButton style={{ backgroundColor: "#fff", border: 'none' }}>
  <Modal.Title className="text-lg font-semibold text-gray-800 w-full">
    {modalTitle || "Redeem Fund"}
  </Modal.Title>
</Modal.Header>

    <Modal.Body>
    <p className="back-clrgreen text-white p-2 mb-2 rounded-4 text-center">
    {allUnitsValue === "Yes"
      ? "Redeem All Units"
      : allUnitsValue === "No" && amount
      ? `Redeem Amount ₹ ${amount}`
      : "Redeem"}
      </p>
      
      <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
      <Col md={12}>
      <Form.Group controlId="allUnits">
      <Form.Label>All Units</Form.Label>
      <Form.Control
      as="select"
      {...register("allUnits", {
        required: "Selection is required",
        onChange: handleAllUnitsChange, // Call handler on change
      })}
      >
      <option value="">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      </Form.Control>
      {errors.allUnits && (
        <p className="error text-danger">
        {errors.allUnits.message}
        </p>
      )}
      </Form.Group>
      </Col>
      </Row>
      
      <Row className="mt-3">
      <Col md={12}>
      <Form.Group controlId="redeemFormAmount">
      <Form.Label hidden={isTransactionAmountDisabled}>Transaction Amount (Redeem Amount)</Form.Label>
      <Form.Control
      type="text"
      placeholder="Enter Transaction Amount"
      hidden={isTransactionAmountDisabled}
      {...register("redeemFormAmount", {                    
        required: !isTransactionAmountDisabled && "Transaction Amount is required",
        onChange: handleAllUnitsChange2,
      })}
      />
      {errors.redeemFormAmount && (
        <p className="error text-danger">
        {errors.redeemFormAmount.message}
        </p>
      )}
      
      {isAmountExceedingCurrentValue && (
        <p className="error text-danger">
          Redeem amount cannot exceed the current fund value of ₹
          {currentFundValue.toLocaleString("en-IN")}.
        </p>
      )}

      </Form.Group>
      </Col>
      </Row>
      
      <Modal.Footer className="border-0">
      {/* <button className='lrgbutton text-white bg-secondary' onClick={onHide}>
        Close
        </button> */}
        
        <button
          type="submit"
          className="lrgbutton text-white text-uppercase"
          disabled={
            !isSelectedFund ||
            isSubmitting ||
            isAmountExceedingCurrentValue
          }
        >
          {isSubmitting ? "Initiating..." : "Initiate"}
        </button>

        </Modal.Footer>
        </Form>
        </Modal.Body>
        </Modal>
      );
    };
    